/* src/app/features/renuncia/pesquisa/renuncia-pesquisa.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
.justificado {
  text-align: justify;
  text-justify: inter-word;
}
/*# sourceMappingURL=renuncia-pesquisa.component.css.map */
